import { BaseEntityService } from '/@/modules/core/app/services/abstracts/BaseEntityService';
import { Route } from '/@/modules/core/app/constants/api.constants';
import { TimeEntry } from '/@/modules/timeentry/models/TimeEntry';
import { BaseModelType } from '@/modules/core/app/models/abstracts/BaseModel';

export class TimeEntryService extends BaseEntityService<TimeEntry> {
  getRoute(): Route {
    return Route.TIMEENTRIES;
  }

  getModel(): BaseModelType<TimeEntry> {
    return TimeEntry;
  }
}

export default new TimeEntryService();
